import {
  dashboard,
  userList,
  userMergeSuggestions,
  benefits,
  gym,
  gymTeacherDashboard,
  schools,
  findPhysicalSpaces,
  tickets,
  workouts,
  finances,
  calendar,
  associationTitles,
  healthInsuranceComparisonReport,
  lifeInsuranceComparisonReport,
  biometryEnroll,
  physicalSpaceReservations,
  physicalAccess,
  customReport,
  contracts,
  campaigns,
  spaceRenting,
  events,
  accountsPayablePage,
  accountsReceivablePage,
  contractsCrm,
  tasksBoard,
  notificationAnalytics,
  analyticsDashboard,
  aiUsageDashboard,
  nutritionDiary,
} from 'app/views/routes'
import { surveyBuilderNavigation } from 'app/navigation/surveyBuilderNavigation'
import { USER_TYPE } from 'app/ducks/auth/types'
import { Theme } from 'app/components/MatxTheme/themes'

// The lateral navigation used to be a flat/grouped list of ~20 routes
// (still readable in the previous shape of `navigations.js` — the
// legacy `Sidenav`/`MatxVerticalNav` components are kept around but are
// no longer wired into `Layout1`). `sections` groups those exact same
// route definitions — same roles/themes/capability gating — into the 8
// major areas rendered by `SectionRail` (the icon rail) and the
// contextual top bar (`Layout1Topbar`), which turns each section's
// visible children into tabs.
//
// A section is visible when `shouldRenderNavigation` passes for it —
// which, absent its own `roles`/`allowedOnThemes`, means "at least one
// child is visible". `contratos` and `administracao` keep the explicit
// role/theme restriction their groups had in the old `navigations.js`.
export const sections = [
  {
    id: 'dashboard',
    name: 'Dashboard',
    icon: 'dashboard',
    children: [dashboard],
  },
  {
    id: 'pessoas',
    name: 'Pessoas',
    icon: 'people',
    children: [userList, associationTitles, userMergeSuggestions],
  },
  {
    id: 'financeiro',
    name: 'Financeiro',
    icon: 'attach_money',
    children: [
      finances,
      accountsPayablePage,
      accountsReceivablePage,
      healthInsuranceComparisonReport,
      lifeInsuranceComparisonReport,
      tickets,
    ],
  },
  {
    id: 'academia',
    name: 'Academia & Treinos',
    icon: 'sports_handball',
    children: [
      { ...workouts, name: 'Treinos', roles: [USER_TYPE.TOTEM] },
      gym,
      gymTeacherDashboard,
      nutritionDiary,
      surveyBuilderNavigation,
      schools,
      biometryEnroll,
    ],
  },
  {
    id: 'contratos',
    name: 'Contratos',
    icon: 'article',
    roles: [USER_TYPE.ADMINISTRATOR],
    allowedOnThemes: [Theme.AMSM, Theme.AFA, Theme.EXOS, Theme.ACTION],
    children: [contracts, contractsCrm],
  },
  {
    id: 'espacos',
    name: 'Espaços',
    icon: 'deck',
    children: [spaceRenting, findPhysicalSpaces, physicalSpaceReservations],
  },
  {
    id: 'engajamento',
    name: 'Engajamento',
    icon: 'campaign',
    children: [campaigns, events, calendar, benefits],
  },
  {
    id: 'administracao',
    name: 'Administração',
    icon: 'admin_panel_settings',
    roles: [USER_TYPE.ADMINISTRATOR],
    allowedOnThemes: [
      Theme.AMSM,
      Theme.ACTION,
      Theme.AFA,
      Theme.EXOS,
      Theme.CIC,
      Theme.CLAB,
      Theme.BIOACADEMIA,
    ],
    children: [
      {
        name: 'Administração',
        path: `${process.env.REACT_APP_BACKEND_URL}/admin`,
        type: 'extLink',
        icon: 'admin_panel_settings',
        roles: [USER_TYPE.ADMINISTRATOR],
        allowedOnThemes: [Theme.AMSM, Theme.CLAB],
      },
      tasksBoard,
      physicalAccess,
      customReport,
      analyticsDashboard,
      aiUsageDashboard,
      notificationAnalytics,
    ],
  },
]
